module.exports = __webpack_public_path__ + "static/img/icon_admin master.a71965e0.svg";